import Player from "@vimeo/player"
import $ from "jquery"

class VimeoVideoComponent {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("VimeoVideoComponent::initialize()")
		this._players = []

		document.querySelectorAll(".bb-vimeo-video").forEach((element) => {
			let player = this._initPlayer(element)
			this._players.push(player)
		})

		$(document).on("click touchend", ".uc-vimeo-bg-link, .uc-vimeo-bg-icon", () => {
			window.UC_UI.showSecondLayer()
		})
	}

	_initPlayer(container) {
		let loop = container.dataset.loop === "true"
		let autoplay = container.dataset.autoplay === "true"
		let muted = container.dataset.muted === "true"

		// no autoplay for hidden elements
		if ($(container).is(":hidden")) {
			autoplay = false
		}

		const player = new Player(container.querySelector(".bb-vimeo-video__video-container"), {
			id: container.dataset.videoId,
			muted: muted || autoplay,
			pip: false,
			autoplay: autoplay,
			loop: loop,
			controls: false,
			keyboard: false,
			playsinline: true,
			byline: false,
			dnt: true, // prevent the player from tracking session data, including cookies
		})

		container.addEventListener(VIMEO_PLAYER_EVENTS.PLAY, () => {
			player.play()
		})
		container.addEventListener(VIMEO_PLAYER_EVENTS.STOP, () => {
			player.pause()
		})
		container.addEventListener(VIMEO_PLAYER_EVENTS.RESET, () => {
			player.pause()
			player.setCurrentTime(0)
		})

		// player.on("loadeddata", () => {
		// 	player._originalElement.parentElement.querySelector(".bb-vimeo-video__placeholder-image").style.opacity = 0
		// })

		player.on("ended", () => {
			container.dispatchEvent(new CustomEvent(VIMEO_PLAYER_EVENTS.ENDED))
		})

		return player
	}
}

export const VIMEO_PLAYER_EVENTS = {
	PLAY: "VimeoVideo:play",
	STOP: "VimeoVideo:stop",
	RESET: "VimeoVideo:reset",
	ENDED: "VimeoVideo:ended",
}

export default new VimeoVideoComponent()
